import React from "react";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";

function OrderAnalyticsPage() {
  return (
    <div className="bg-gray-100 py-2 min-h-screen">
      <OrderMainNav />
      <div className="container mx-auto my-6">OrderAnalyticsPage</div>
    </div>
  );
}

export default OrderLayerBlueprint(OrderAnalyticsPage);
